import { api } from 'common';

import { FaxBlockFormFields } from './FormFields';
import { FaxBlockDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const faxConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'SendFax',
  defaultConfig: {
    fileReference: '',
    faxNumber: '',
    attachDocumoCoversheet: false,
    documoCoversheet: {
      id: '',
      recipientName: '',
      senderName: '',
      subject: '',
      notes: '',
    },
    runMode: api.FlowDefinition.RunMode.Live,
  },
  configFields: {
    schema: api.FlowDefinition.FaxBlockConfigSchema,
    FormFields: FaxBlockFormFields,
  },
  documentationMarkdown: FaxBlockDocumentationMarkdown,
};
